import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCMSContentbyId } from '../cms-actions';
import { getBlockComponentForContent } from '../../utils/cms-utils';

const CMSItem = ({ id, depth }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.cms?.item[id]);

    useEffect(() => {
        CMSItem.fetchCMSItem(dispatch, id, depth);
    }, [dispatch, id, depth]);

    if (!data || !id) {
        return null;
    }

    return getBlockComponentForContent({ data });
};

CMSItem.fetchCMSItem = (dispatch, id, depth) => dispatch(fetchCMSContentbyId({ resourceId: id, depth }));

export default CMSItem;
